import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { NavItem } from 'src/app/models/navigation.model';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-prev-next-navigation',
  templateUrl: './prev-next-navigation.component.html',
  styleUrls: ['./prev-next-navigation.component.scss']
})
export class PrevNextNavigationComponent implements OnInit {
  previousPage: NavItem | null = null;
  nextPage: NavItem | null = null;
  currentPath = '';

  constructor(
    private router: Router,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    // Update previous and next links when navigation occurs
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentPath = event.urlAfterRedirects;
      this.updateNavLinks();
    });
    
    // Set initial navigation links
    this.currentPath = this.router.url;
    this.updateNavLinks();
  }

  private updateNavLinks(): void {
    this.previousPage = this.navigationService.getPreviousPage(this.currentPath);
    this.nextPage = this.navigationService.getNextPage(this.currentPath);
  }
}
